export const QueryKeys = {
  AllVendorsList: "AllVendorsList",
  ThirdPartyVendorToken: "ThirdPartyVendorToken",
  AllFrameworksList: "AllFrameworksList",
  ControlSets: "ControlSets",
  StytchMembersList: "StytchMembersList",
  SessionDetails: "SessionDetails",
  Questionnaire: "Questionnaire",
  TPRASummary: "TPRASummary",
  TPRAVendorsList: "TPRAVendorsList", // For TPRA Dashboard vendors API
  TPRABreachHistoryList: "TPRABreachHistoryList", // For TPRA Dashboard breach history API
  TPRARisksList: "TPRARisksList", // For TPRA Dashboard risks API
  TPRASessions: "TPRASessions", // For TPRA Dashboard sessions API
};

/**
 * Query key factory for TPRA Vendors
 * Provides type-safe, structured query keys for TanStack Query caching
 *
 * Usage:
 *   queryKey: tpraVendorsQueryKeys.list({ page: 1, page_size: 50 })
 */
export const tpraVendorsQueryKeys = {
  all: [QueryKeys.TPRAVendorsList] as const,
  lists: () => [...tpraVendorsQueryKeys.all, "list"] as const,
  list: (filters: Record<string, any>) => [...tpraVendorsQueryKeys.lists(), filters] as const,
};

/**
 * Query key factory for TPRA Breach History
 * Provides type-safe, structured query keys for TanStack Query caching
 *
 * Usage:
 *   queryKey: breachHistoryQueryKeys.list({ page: 1, page_size: 20 })
 */
export const breachHistoryQueryKeys = {
  all: [QueryKeys.TPRABreachHistoryList] as const,
  lists: () => [...breachHistoryQueryKeys.all, "list"] as const,
  list: (filters: Record<string, any>) => [...breachHistoryQueryKeys.lists(), filters] as const,
};

/**
 * Query key factory for TPRA Risks
 * Provides type-safe, structured query keys for TanStack Query caching
 *
 * Usage:
 *   queryKey: risksQueryKeys.list({ page: 1, page_size: 25 })
 */
export const risksQueryKeys = {
  all: [QueryKeys.TPRARisksList] as const,
  lists: () => [...risksQueryKeys.all, "list"] as const,
  list: (filters: Record<string, any>) => [...risksQueryKeys.lists(), filters] as const,
};
